export async function swal (options){
    const {default:Swal} =await import(/* webpackChunkName: "sweetalert2" */ 'sweetalert2')
  return Swal.fire({
    ...options,
    didOpen: (popup) => { //Callback ejecuta ccuando abre el dialog o ventana
      // El z-index del v-dialog de Vuetify (~2400) tapa al swal (~1060).
      // Subimos el contenedor del swal para que quede SIEMPRE por encima.
      const container = Swal.getContainer();
      if (container) container.style.zIndex = "100000";
      if (typeof options.didOpen === "function") options.didOpen(popup);
    },
  })
}

export async function celebrar(){
    const confetti=(await import(/* webpackChunkName: "confetti" */ 'canvas-confetti')).default
  confetti()

}